import { format } from 'date-fns';
import { CalendarItem, CalendarEntry, FollowUpEntry, TaskEntry, WorkAssignmentEntry, CallLogEntry } from './CalendarTypes';

export class CalendarUtils {
  // Convert 24-hour time to 12-hour AM/PM format
  static formatTime(time: string): string {
    const [hours, minutes] = time.split(':');
    const hour = parseInt(hours, 10);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const displayHour = hour % 12 || 12;
    return `${displayHour}:${minutes} ${ampm}`;
  }

  // Combine journal entries, followups, tasks, work assignments, and call logs and sort them chronologically
  static combineAndSortEntries(
    journalEntries: CalendarEntry[],
    followupEntries: FollowUpEntry[],
    taskEntries: TaskEntry[],
    workAssignmentEntries: WorkAssignmentEntry[],
    callLogEntries: CallLogEntry[]
  ): CalendarItem[] {
    const combined: CalendarItem[] = [
      ...journalEntries,
      ...followupEntries,
      ...taskEntries,
      ...workAssignmentEntries,
      ...callLogEntries
    ];
    
    // Sort by time (startTime for journals, followUpTime for followups, dueDate for tasks and work assignments)
    const sorted = combined.sort((a, b) => {
      let timeA: string;
      let timeB: string;
      
      if (a.entryType === 'journal') {
        timeA = a.startTime;
      } else if (a.entryType === 'followup') {
        timeA = format(a.followUpTime.toDate(), 'HH:mm');
      } else if (a.entryType === 'callLog') {
        timeA = format(a.callTimestamp.toDate(), 'HH:mm');
      } else {
        // Both tasks and work assignments use dueDate
        timeA = format(a.dueDate.toDate(), 'HH:mm');
      }
      
      if (b.entryType === 'journal') {
        timeB = b.startTime;
      } else if (b.entryType === 'followup') {
        timeB = format(b.followUpTime.toDate(), 'HH:mm');
      } else if (b.entryType === 'callLog') {
        timeB = format(b.callTimestamp.toDate(), 'HH:mm');
      } else {
        // Both tasks and work assignments use dueDate
        timeB = format(b.dueDate.toDate(), 'HH:mm');
      }
      
      return timeA.localeCompare(timeB);
    });
    
    return sorted;
  }

  // Check if user can edit a specific entry
  static canEditEntry(entryUserId: string, currentUserId: string): boolean {
    return entryUserId === currentUserId;
  }

  // Check if user can add new entries
  static canAddEntry(selectedUserId: string, currentUserId: string): boolean {
    return selectedUserId === currentUserId;
  }
}
